import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RepresentantSearch from './RepresentantSearch';
import { fetchSuggestionsRepresentant, clearSuggestionsRepresentant, setRepresentantValue } from 'store/representant/representantActions';

class RepresentantSearchContainer extends React.Component {
    handleSearchRepresentants = (searchValue) => {
        this.props.fetchSuggestionsRepresentant(searchValue);
    }

    handleClearRepresentants = () => {
        this.props.clearSuggestionsRepresentant();
    }

    handleChange = (value) => {
        const { selectedCode } = this.props;
        this.props.setRepresentantValue(value, selectedCode);
    }

    handleSuggestionSelected = (code, value) => {
        this.props.setRepresentantValue(value, code);
        this.props.onChange(code);
    }

    render() {
        const { representants, value, selectedCode, isRequired, error } = this.props;

        return (
            <RepresentantSearch
                representants={representants}
                onSearch={this.handleSearchRepresentants}
                onChange={this.handleChange}
                onClear={this.handleClearRepresentants}
                error={error}
                isRequired={isRequired}
                onSuggestionSelected={this.handleSuggestionSelected}
                value={value}
                selectedCode={selectedCode}
            />);
    }
}

const mapStateToProps = (state, ownProps) => ({
    representants: state.representant[ownProps.namespace].suggestions.items,
    value: state.representant[ownProps.namespace].suggestions.value,
    selectedCode: state.representant[ownProps.namespace].suggestions.selectedCode
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchSuggestionsRepresentant: (searchValue) => dispatch(fetchSuggestionsRepresentant(ownProps.namespace, searchValue)),
    clearSuggestionsRepresentant: () => dispatch(clearSuggestionsRepresentant(ownProps.namespace)),
    setRepresentantValue: (value, selectedCode) => dispatch(setRepresentantValue(ownProps.namespace, value, selectedCode))
});

RepresentantSearch.propTypes = {
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(RepresentantSearchContainer);